<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        class="woom-bike-outline woom-original-1-plus"
        viewBox="0 0 800 600"
        style="enable-background: new 0 0 800 600"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <g>
                <g>
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M299,385.6c-4.4,48.6-45.2,86.7-94.9,86.7c-52.6,0-95.3-42.7-95.3-95.3s42.7-95.3,95.3-95.3
						c39.8,0,73.9,24.4,88.2,59" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M296.3,352.6c1,3.9,1.8,7.9,2.3,11.9" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M321.8,386.3C317.5,447.5,266.5,495,204.1,495C138.9,495,86,442.2,86,376.9s52.9-118.1,118.1-118.1
						c49.4,0,91.8,30.4,109.4,73.5" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M317.8,344.9c1.8,6.4,2.9,12.5,3.6,19.2" />
                </g>
            </g>
            <g id="Layer_1_copy_00000065763390523923567090000016042896737875987094_">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9
					L665,376.9L665,376.9z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M665,376.9L665,376.9L665,376.9L665,376.9L665,376.9" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="665,376.9 665,376.9 665,376.9 665,376.9" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9
					L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9C665.1,376.9,665.1,376.9,665,376.9L665,376.9L665,376.9L665,376.9
					L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9C665.1,376.9,665,376.9,665,376.9L665,376.9L665,376.9z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M665,376.9L665,376.9L665,376.9L665,376.9C665.1,376.9,665.1,376.9,665,376.9
					C665.1,376.9,665,376.9,665,376.9L665,376.9L665,376.9z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M665,376.9L665,376.9L665,376.9z" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="665,376.9 665,376.9 665,376.9 665,376.9" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="665,376.9 665,376.9 665,376.9 665,376.9" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9L665,376.9z" />
                <g>
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M637,286c8.5-2.5,18.7-4.4,28-4.4c52.6,0,95.3,42.7,95.3,95.3s-42.7,95.3-95.3,95.3
						c-52.6,0-95.3-42.7-95.3-95.3c0-32.9,17.8-62.4,43.1-79.6" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M627.8,264.8c11.7-3.9,24.2-6,37.2-6c65.2,0,118.1,52.9,118.1,118.1S730.2,495,665,495
						s-118.1-52.9-118.1-118.1c0-42.2,22.1-79.2,55.3-100.1" />
                </g>
            </g>
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M345.3,274.4l15.4,39.6l-130.4,51.4c0,0-19,1-27.1,1.9c-8.1,0.8-9.8,9.4-8.1,13.6c0.2,0.5,1.4,3.1,1.6,3.4
				c1.1,1.7,3.6,1.1,3.9-0.9c0.3-3,0.9-8.9,3.4-8.9c4,0,4.4,0.5,4.2,2.8c-0.1,1.5,0.2,7.9,2.9,8.1c2.7,0.2,182.3,0.8,190.4,0.8
				s47.3-0.2,67.1-11.9c19.8-11.7,29.6-18.3,41.2-36.5c11.7-18.1,65.4-116,65.4-116l2.9,10.2l30.8-12.7l-6.2-11l-15.4-38.5l-2.9-11.5
				l-30.8,12.1l2.3,5.6c0,0-123.1,96.9-129.8,101c-6.7,4.2-13.1,7.9-30,7.9s-24.4-0.2-24.4-0.2l-7.9-18.5L345.3,274.4z" />
            <polygon
                class="fill-none stroke-woom-black stroke-2"
                points="263,365 366.1,327.7 380.3,363.5" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M379.4,303.9l22.9,57.5c0,0,33.1-4,51.2-12.9c18.1-9,30-22.1,39.8-39.8C503.2,291,549,208.1,549,208.1
				s-103.4,78.7-112.3,83.7s-20.8,11-34.2,11.5C389.2,303.7,379.4,303.9,379.4,303.9z" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="340.9"
                y1="387"
                x2="340.9"
                y2="393.7" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="349.7"
                y1="386.8"
                x2="349.7"
                y2="393.7" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="461.1"
                y1="378.3"
                x2="463.4"
                y2="383.3" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="468.6"
                y1="374.3"
                x2="471.1"
                y2="379.5" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M484.4,372.5c0,0-23.9,15.4-42.9,18.3c-19.7,3-106.7,3-106.7,3l-0.4,7.7c0,0,89.3-0.2,107.9-3
				c17.4-2.6,40.2-14.7,46.4-20.1C486.9,374.1,484.4,372.5,484.4,372.5z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M665.6,352.7c-0.4,0.2-18.5,9-18.5,9s-55.6-105.4-56.9-107.9c-1.2-2.5-6-13,7.1-18.8s19.4,6.1,19.4,6.1
				L665.6,352.7z" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="578.1"
                y1="232.1"
                x2="590.2"
                y2="253.7" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="609"
                y1="219.4"
                x2="616.7"
                y2="241" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M649.1,361l0.2,4.5c0,0,6.8,15.5,8.5,18.5c1.6,3,8.1,2.5,8.1,2.5l-3.7-8.6c0,0-1.5-2.3,1.8-4.3
				s5.5,2.2,5.5,2.2l3.8,7.6c0,0,3.2-3.7,3-7.8s-8.1-19.3-8.1-19.3l-6-1.7" />
            <path
                class="st1"
                d="M545.4,267l-0.8,1.1c-0.1,0.3-0.4,0.3-0.8,0.1l-8.4-2.7c-2.8-0.9-5.8-0.4-7.9,2.3c-1,1.4-1.5,3.1-1.2,4.8
				c-1.9,0.4-3.4,1.6-4.3,2.7c-2.2,2.9-2.2,5.9-0.3,8.2c-3.2-0.5-6.4,0.8-8.5,3.4c-1.9,2.6-2.3,5.9-1.1,8.7c-3-0.3-6.1,0.9-8.1,3.6
				c-1.9,2.6-2.3,5.9-1.1,8.7l-1.8-1.3c-1-0.7-2.3-0.6-3,0.4s-0.5,2.4,0.4,3l7.4,5.6c1.1,0.8,1.1,2.5,0.4,3.6c-0.7,1-2.4,1.5-3.5,0.6
				l-0.1-0.1l-7.3-5.5c-1-0.7-2.3-0.6-3,0.4c-0.7,1-0.5,2.4,0.4,3l7.3,5.5l0.1,0.1c1.2,0.9,1.1,2.5,0.5,3.3c-0.7,0.8-1.6,1.3-3.1,0.8
				l-9.1-3.1c-2.2-0.7-3.7,0.5-4.2,1.3l-1.3,1.8c-0.7,1-0.6,2.3,0.4,2.9c1,0.7,2.2,0.5,3-0.5l0.8-1.1c0.1-0.3,0.4-0.3,0.8-0.1l8.4,2.7
				c2.8,0.9,5.8,0.4,7.9-2.3c1-1.4,1.5-3.1,1.2-4.8c1.9-0.4,3.4-1.6,4.3-2.7c2.1-2.8,2.2-5.9,0.3-8.2c3.2,0.5,6.4-0.8,8.5-3.4
				c1.9-2.6,2.3-5.9,1.1-8.7c3,0.3,6.1-0.9,8.1-3.6c1.9-2.6,2.3-5.9,1.1-8.7l1.8,1.3c1,0.7,2.3,0.6,3-0.4s0.5-2.4-0.4-3l-7.4-5.6
				c-1.1-0.8-1.1-2.5-0.4-3.6c0.7-1,2.4-1.5,3.5-0.6l0.1,0.1l7.3,5.5c1,0.7,2.3,0.6,3-0.4c0.7-1,0.5-2.4-0.4-3l-7.3-5.5l-0.1-0.1
				c-1.2-0.9-1.1-2.5-0.5-3.3c0.7-0.8,1.6-1.3,3.1-0.8l9.1,3.1c2.2,0.7,3.7-0.5,4.2-1.3l1.3-1.8c0.7-1,0.6-2.3-0.4-2.9
				C547.4,265.7,546.1,266,545.4,267z M515,307.3c-1.6,2.1-4.5,2.4-6.5,0.9c-2.1-1.6-2.5-4.5-1-6.5c1.6-2.1,4.5-2.5,6.6-1
				C516.1,302.4,516.6,305.3,515,307.3z M524.2,295.1c-1.6,2.1-4.5,2.4-6.5,0.9c-2.1-1.6-2.5-4.5-1-6.5c1.6-2.1,4.5-2.5,6.6-1
				S525.8,293,524.2,295.1z" />
        </g>
        <g class="saddle-normal">
            <g>
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="329.8"
                    y1="233.1"
                    x2="346.1"
                    y2="272.3" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="344.2"
                    y1="226.3"
                    x2="361.7"
                    y2="266.2" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M307.5,190.8c0,0,38.7,1.2,48.3,1.2s25.2-1,30.8-1.5c5.6-0.4,14.8,1.2,17.7,7.1c2.9,5.8,4.5,10.4,1.2,11.5
					c-3.2,1-30.4,4.6-39.2,7.3c-8.7,2.7-21.7,10-29.2,13.3c-7.5,3.3-9.7,5.8-19.4,2.5c-9.7-3.3-33.1-11.2-39.2-14.4s-7.8-7-7.1-11.9
					s-1-14.4,8.3-15.4S307.5,190.8,307.5,190.8z" />
            </g>
        </g>
        <g class="handlebar-normal">
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="553.6,169.6 543.2,145.5 545.3,138.1 567,121.5" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M566.1,56c0,0,1.9,72.1,1.9,75.3s3.9,8.3,10.4,7.9s8.1-7.6,7.9-8.8c-0.2-1.1-2.2-47.4-3.9-62.9
				c-1.7-15.4-5.9-25.2-5.9-25.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M560.6,30.3c1.1-0.3,1.5-0.4,2.8-0.4c6.9,0,12.4,5.7,12.4,12.7s-5.6,12.7-12.4,12.7c-1,0-1.4,0-2.4-0.2" />
            <circle
                class="fill-none stroke-woom-black stroke-2"
                cx="549.5"
                cy="43"
                r="16.5" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M585.8,121.1l7,1.2l-2,16.2c0,0-7.3,0.9-10.5,3.9c-3.2,3-5,8.3-5,8.3l9.2,7.6" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="550.2"
                y1="161.4"
                x2="575.2"
                y2="150.7" />
        </g>
        <g class="tyres hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="203.4"
                            y1="259"
                            x2="203.4"
                            y2="495.2" />
                        <g>
                            <rect
                                x="195.6"
                                y="257.8"
                                class="fill-woom-red stroke-woom-red"
                                width="15.7"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="195.6"
                                y="494"
                                class="fill-woom-red stroke-woom-red"
                                width="15.7"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="665.5"
                            y1="259"
                            x2="665.5"
                            y2="495.2" />
                        <g>
                            <rect
                                x="657.7"
                                y="257.8"
                                class="fill-woom-red stroke-woom-red"
                                width="15.7"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="657.7"
                                y="494"
                                class="fill-woom-red stroke-woom-red"
                                width="15.7"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="cockpit hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="548.8"
                            y1="42.4"
                            x2="548.8"
                            y2="495" />
                        <g>
                            <rect
                                x="541"
                                y="41"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.7" />
                        </g>
                        <g>
                            <rect
                                x="541"
                                y="493.6"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.7" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="steering-angle hidden">
            <g class="inline">
                <g id="w2-steering-angle_1_">
                    <polyline
                        class="h-line fill-none stroke-woom-red stroke-3"
                        points="532.7,94.5 591.7,220.6 466.6,220.6" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M542.7,220.3c0-19.5,11.6-36.4,28.2-44" />
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="595.3"
                                y1="227"
                                x2="597"
                                y2="230.7" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="600.3"
                                y1="237.7"
                                x2="717.9"
                                y2="488" />
                            <polyline
                                class="h-line fill-none stroke-woom-red stroke-3"
                                points="719.6,491.5 721.3,495.1 717.3,495.1" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="709.5"
                                y1="495.1"
                                x2="604.1"
                                y2="495.1" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="600.2"
                                y1="495.1"
                                x2="596.2"
                                y2="495.1" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M671.7,495.3c0-1.3,0.1-2.7,0.2-4" />
                        <path
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            d="M673.6,482c3.1-10.8,9.8-20.1,18.8-26.4" />
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M696.4,453.1c1.2-0.7,2.3-1.3,3.6-1.8" />
                    </g>
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="560.6"
                            y1="143.7"
                            x2="312.8"
                            y2="143.7" />
                        <g>
                            <rect
                                x="559.4"
                                y="135.9"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                        <g>
                            <rect
                                x="311.6"
                                y="135.9"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="wheelbase hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="666.4"
                            y1="378.7"
                            x2="205"
                            y2="378.7" />
                        <g>
                            <rect
                                x="665.2"
                                y="370.9"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                        <g>
                            <rect
                                x="203.8"
                                y="370.9"
                                class="fill-woom-red stroke-woom-red"
                                width="2.4"
                                height="15.6" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g
                id="geo-w2-G-F-seat-tube-angle"
                class="inline">
                <polyline
                    class="h-line fill-none stroke-woom-red stroke-3"
                    points="349.5,257.7 444.5,494.8 213.4,494.8" />
            </g>
            <path
                class="h-line-miter inline fill-none stroke-woom-red stroke-3"
                d="M397.7,494.9c0-19.5,11.6-36.4,28.2-44" />
        </g>
        <g class="min-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="339.6"
                                y1="210.1"
                                x2="334.8"
                                y2="210.1" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="324.9"
                                y1="210.1"
                                x2="35.7"
                                y2="210.1" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="30.8"
                                y1="210.1"
                                x2="25.9"
                                y2="210.1" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="12.8"
                                    y1="210.1"
                                    x2="12.8"
                                    y2="494.8" />
                                <g>
                                    <rect
                                        x="5"
                                        y="209"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.2" />
                                </g>
                                <g>
                                    <rect
                                        x="5"
                                        y="493.7"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.2" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="338.6"
                y1="253.1"
                x2="347.2"
                y2="273.4" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="353"
                y1="246.3"
                x2="362.3"
                y2="267.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M316.3,210.8c0,0,38.7,1.2,48.3,1.2s25.2-1,30.8-1.5c5.6-0.4,14.8,1.2,17.7,7.1c2.9,5.8,4.5,10.4,1.2,11.5
				c-3.2,1-30.4,4.6-39.2,7.3c-8.7,2.7-21.7,10-29.2,13.3c-7.5,3.3-9.7,5.8-19.4,2.5c-9.7-3.3-33.1-11.2-39.2-14.4s-7.8-7-7.1-11.9
				c0.7-4.8-1-14.4,8.3-15.4S316.3,210.8,316.3,210.8z" />
        </g>
        <g class="max-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="313"
                                y1="143"
                                x2="35.5"
                                y2="143" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="30.6"
                                y1="143"
                                x2="25.7"
                                y2="143" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="12.6"
                                    y1="143"
                                    x2="12.6"
                                    y2="494.4" />
                                <g>
                                    <rect
                                        x="4.8"
                                        y="141.6"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.8" />
                                </g>
                                <g>
                                    <rect
                                        x="4.8"
                                        y="493"
                                        class="fill-woom-red stroke-woom-red"
                                        width="15.6"
                                        height="2.8" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="310.8"
                    y1="188.1"
                    x2="346.1"
                    y2="272.3" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="325.3"
                    y1="181.6"
                    x2="361.7"
                    y2="266.2" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M288.5,145.8c0,0,38.7,1.2,48.3,1.2s25.2-1,30.8-1.5c5.6-0.4,14.8,1.2,17.7,7.1c2.9,5.8,4.5,10.4,1.2,11.5
					c-3.2,1-30.4,4.6-39.2,7.3c-8.7,2.7-21.7,10-29.2,13.3c-7.5,3.3-9.7,5.8-19.4,2.5c-9.7-3.3-33.1-11.2-39.2-14.4
					c-6-3.1-7.8-7-7.1-11.9c0.7-4.8-1-14.4,8.3-15.4S288.5,145.8,288.5,145.8z" />
            </g>
        </g>
        <g class="handlebar-adjustability hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <path
                                class="h-line fill-none stroke-woom-red stroke-3"
                                d="M566.8,14.9c23.4,2.1,42,20.7,44.1,44.1" />
                            <g>
                                <polygon
                                    class="fill-woom-red stroke-woom-red"
                                    points="568,21 558.2,14.2 569.1,9.1" />
                            </g>
                            <g>
                                <polygon
                                    class="fill-woom-red stroke-woom-red"
                                    points="604.8,57.8 611.7,67.6 616.7,56.7" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="553.6,169.6 543.2,145.5 545.3,138.1 564.1,123.9" />
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M539.4,65.2c0,0,28.2,66.3,29.4,69.3s6.7,6.3,12.5,3.5c5.8-2.8,4.8-10.1,4.1-11.1c-0.6-1-19.5-43.3-26.7-57
					s-16.4-22.9-16.4-22.9" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M524.9,43.4c0.9-0.7,1.3-0.9,2.4-1.4c6.4-2.5,13.6,0.7,16.2,7.3s-0.5,13.9-6.9,16.4c-1,0.4-1.3,0.6-2.3,0.7" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="519.2"
                    cy="59.2"
                    r="16.5" />
            </g>
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M582.9,120.3l9.8,2l-2,16.2c0,0-7.3,0.9-10.5,3.9c-3.2,3-5,8.3-5,8.3l9.2,7.6" />
        </g>
        <g class="stand-over-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="12.3"
                            y1="247.4"
                            x2="12.3"
                            y2="494.5" />
                        <g>
                            <rect
                                x="4.5"
                                y="246.3"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                        <g>
                            <rect
                                x="4.5"
                                y="493.3"
                                class="fill-woom-red stroke-woom-red"
                                width="15.6"
                                height="2.3" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="463.7"
                                y1="247.3"
                                x2="458.7"
                                y2="247.3" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="448.7"
                                y1="247.3"
                                x2="35.2"
                                y2="247.3" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="30.3"
                                y1="247.3"
                                x2="25.2"
                                y2="247.3" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>
